import dayjs from "dayjs";

export const formatDateTime = (date) =>
  dayjs(date).format("DD MMM YYYY, hh:mm A");

export const formatDate = (date) =>
  dayjs(date).format("DD/MM/YYYY");

export const indianCurrencyFormat = (num) => {
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};


export default dayjs;